/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Card, Image, Button } from "react-bootstrap";
import Emp_data_pic from "../../assets/images/Emp_data_pic.png";
import { AiOutlineSearch } from "react-icons/ai";
import { AutoComplete, DatePicker, Select } from "antd";
import "./report.css";
import moment from "moment";

import {
  Table,
  TableHeadCell,
  TableBody,
  TableBodyCell,
  TableHead,
} from "../setting/PatientPortalSettings/StyledComponents";
import { Tablerow } from "../patient/StyledComponent";
import { globalColor, globalFont } from "../utils/RepeatFunctions/Schedule";
import { Decrypt_Value } from "../../MiddleWare/EncryptDecrypt";
import { Encrypt_Value } from "../schedule/EncryptDecrypt";
import axiosInstance from "../../axios/axios";
import Loader from "../popups/Loading";
import { parsePhoneForDisplay } from "../patient/ParsePhoneForDisplay";
import axios from "axios";
import { fileurl } from "../../axios/url";

// const { RangePicker } = DatePicker;
const { Option } = Select;

function UnappliedCreditReportTable() {
  // date format from local storage (same pattern)
  const dateFormat = localStorage.getItem("dateFormat");

  // auth / user values (same as other components)
  let storedNames = Decrypt_Value(localStorage.getItem("setroles"), "vozo");
  let authorized = Decrypt_Value(localStorage.getItem("authorized"), "vozo");
  let main_pro = Decrypt_Value(localStorage.getItem("main_pro"), "vozo");
  let owner_id = Decrypt_Value(localStorage.getItem("owner_id"), "vozo");
  let user_ID = Decrypt_Value(localStorage.getItem("user_id"), "vozo");

  // Spinner / loading
  const [spinner, setspinner] = useState(true);

  // Filters & search states
  const [patientSearchStr, setPatientSearchStr] = useState(""); // typed patient name
  const [patientId, setPatientId] = useState(""); // selected pid (value from patient select)
  const [patientOptions, setPatientOptions] = useState([]);
  const [forpatsrchload, setforpatsrchload] = useState(false);
  const [patsrchvalue, setpatsrchvalue] = useState("");
  const [showTitle, setShowTitle] = useState(true);

  const [facilityList, setFacilityList] = useState([]);
  const [facility, setFacility] = useState(""); // selected office id

  const [fromdt, setfrom] = useState(
    moment().add(-7, "days").format("YYYY-MM-DD"),
  );
  const [todt, settodt] = useState(moment().format("YYYY-MM-DD"));

  // main rows and paged display (same naming as eligibility to keep consistency)
  const [mainrows, setmainrows] = useState([]); // full data source (dummy OR API)
  const [tableData, setTableData] = useState([]); // paged rows shown in table
  const [showLoading, setShowLoading] = useState("reportDivnone"); // hide load more initially if not needed
  const [offVal, setoffval] = useState(40);
  const [load_flag, setload_flag] = useState(0);

  // country codes for phone display in patient dropdown
  const [countryCodes, setCountryCodes] = useState([]);

  // Dummy data for first load (10 rows) — keys you confirmed
  // const dummyData = [
  //   {
  //     patient: "Henry James",
  //     facility: "Pulmonary Health Limited",
  //     payment_date: "2025-11-20",
  //     original_paid_amount: 3000,
  //     applied_amount: 2000,
  //     unapplied_credit: 1000,
  //     current_patient_balance: 1000,
  //   },
  //   {
  //     patient: "Maya Patel",
  //     facility: "Eastside Clinic",
  //     payment_date: "2025-10-15",
  //     original_paid_amount: 1500,
  //     applied_amount: 500,
  //     unapplied_credit: 1000,
  //     current_patient_balance: 500,
  //   },
  //   {
  //     patient: "John Carter",
  //     facility: "Pulmonary Health Limited",
  //     payment_date: "2025-09-30",
  //     original_paid_amount: 800,
  //     applied_amount: 200,
  //     unapplied_credit: 600,
  //     current_patient_balance: 300,
  //   },
  //   {
  //     patient: "Lina Gomez",
  //     facility: "Downtown Medical",
  //     payment_date: "2025-08-22",
  //     original_paid_amount: 1200,
  //     applied_amount: 1200,
  //     unapplied_credit: 0,
  //     current_patient_balance: 0,
  //   },
  //   {
  //     patient: "Arjun Singh",
  //     facility: "Green Valley Clinic",
  //     payment_date: "2025-07-10",
  //     original_paid_amount: 2400,
  //     applied_amount: 1400,
  //     unapplied_credit: 1000,
  //     current_patient_balance: 200,
  //   },
  //   {
  //     patient: "Sara Ali",
  //     facility: "Eastside Clinic",
  //     payment_date: "2025-06-05",
  //     original_paid_amount: 500,
  //     applied_amount: 0,
  //     unapplied_credit: 500,
  //     current_patient_balance: 250,
  //   },
  //   {
  //     patient: "Noah Brown",
  //     facility: "Downtown Medical",
  //     payment_date: "2025-05-19",
  //     original_paid_amount: 1000,
  //     applied_amount: 600,
  //     unapplied_credit: 400,
  //     current_patient_balance: 400,
  //   },
  //   {
  //     patient: "Priya Nair",
  //     facility: "Green Valley Clinic",
  //     payment_date: "2025-04-04",
  //     original_paid_amount: 1800,
  //     applied_amount: 800,
  //     unapplied_credit: 1000,
  //     current_patient_balance: 900,
  //   },
  //   {
  //     patient: "Carlos Mendes",
  //     facility: "Pulmonary Health Limited",
  //     payment_date: "2025-03-12",
  //     original_paid_amount: 2200,
  //     applied_amount: 1200,
  //     unapplied_credit: 1000,
  //     current_patient_balance: 1000,
  //   },
  //   {
  //     patient: "Emily White",
  //     facility: "Eastside Clinic",
  //     payment_date: "2025-02-28",
  //     original_paid_amount: 700,
  //     applied_amount: 200,
  //     unapplied_credit: 500,
  //     current_patient_balance: 100,
  //   },
  // ];

  // helper: delay
  const timeout = (ms) => new Promise((res) => setTimeout(res, ms));

  // ------------------------- PATIENT SEARCH (same as Eligibility) -------------------------
  const PatientSearch = (val) => {
    setpatsrchvalue(val);
    setforpatsrchload(true);
    setPatientSearchStr(val);
    if (val === "") {
      setPatientId("");
    }
  };

  const PatientSelect = (value) => {
    // value like pid-name
    if (!value) return;
    const a = value.split("-");
    setPatientId(a[0] || "");
    setPatientSearchStr(a[1] || "");
  };

  const patdropdown = () => {
    // build article string same as Eligibility's patdropdown
    let article =
      "limit=10&fname=" +
      patientSearchStr +
      "&authorized=" +
      authorized +
      "&main_pro=" +
      main_pro +
      "&userID=" +
      user_ID +
      "&pat_share=" +
      storedNames.pat_share +
      "&owner_id=" +
      owner_id;

    let data = Encrypt_Value(article, "vozo");
    axiosInstance
      .get("/vozo/patientsearch?search=" + data)
      .then((res) => {
        let res3 = Decrypt_Value(res.data, "vozo");
        if (res3.length > 0) {
          setPatientOptions(res3);
        } else {
          setPatientOptions([]);
        }
      })
      .catch((err) => {
        setPatientOptions([]);
      });
  };

  // debounce patient search
  useEffect(() => {
    let cancelled = false;
    const doSearch = async () => {
      await timeout(1000);
      if (!cancelled && forpatsrchload === true) {
        patdropdown();
      }
    };
    doSearch();
    return () => {
      cancelled = true;
    };
  }, [patsrchvalue]);

  // ------------------------- FACILITY LIST (same as ProductProcedures) -------------------------
  const getFacilityDatas = async () => {
    let input =
      "authorized=" + authorized + "&main_pro=" + main_pro + "&group_id=";
    // group_id not required; we keep same pattern
    let dta = Encrypt_Value(input, "vozo");
    try {
      const res = await axiosInstance.get(
        "/vozonew/facility/all?search=" + dta,
      );
      let res3 = Decrypt_Value(res.data, "vozo");
      setFacilityList(res3);
    } catch (err) {
      setFacilityList([]);
    }
  };

  // ------------------------- COUNTRY CODES (for phone display in patient options) -------------------------
  const handleCountryFetch = async () => {
    try {
      const res = await axios.get(
        fileurl + "/interface/register/get_country_code_rpm.php",
      );
      setCountryCodes(res.data);
    } catch (err) {
      setCountryCodes([]);
    }
  };

  // ------------------------- FIRST LOAD (dummy) -------------------------
  useEffect(() => {
    const init = async () => {
      const article = {
        patientid: patientId || "",
        userid: "", // no provider filter here (not required by your columns)
        payerid: "",
        startdate: fromdt,
        enddate: todt,
        limit: 40,
        offset: 0,
        authorized: authorized,
        main_pro: main_pro,
        owner_id: owner_id,
        userID: user_ID,
        pat_share: storedNames.pat_share,
        facility: facility || "",
      };

      try {
        const d = Encrypt_Value(article, "vozo");
        // Replace the endpoint below with real backend path when available
        const res = await axiosInstance.put("/vozo/unappliedCredit", d);
        const decoded = Decrypt_Value(res.data, "vozo");
        setmainrows(decoded);
        setTableData(decoded.slice(0, 15)); // our dummy is <=15
        setShowLoading(decoded.length > 15 ? "block" : "none");
        setspinner(false);
        if (decoded.length > 10) {
          setShowLoading("reportDivblock");
        } else {
          setShowLoading("reportDivnone");
        }
        // fileurl fetch optional: keep as friendly attempt
        // no import of fileurl to avoid breaking if missing — wrapped in try
        // eslint-disable-next-line no-undef
        // If your project uses axios + fileurl like Eligibility, uncomment and adapt:
        // const res = await axios.get(fileurl + "/interface/register/get_country_code_rpm.php");
        // setCountryCodes(res.data);
      } catch (err) {}
    };

    init();
    // load dummy rows and facilities and country codes

    // show load more only if mainrows length > shown

    getFacilityDatas();
    handleCountryFetch();
  }, []);

  // ------------------------- UPDATE / FILTER (attempt API, fallback to dummy filter) -------------------------
  const onSubmit = async () => {
    // reset pagination state
    setoffval(40);
    setload_flag(0);

    // prepare payload similar to Eligibility pattern, include facility under 'office' (backend can adapt)
    const article = {
      patientid: patientId || "",
      userid: "", // no provider filter here (not required by your columns)
      payerid: "",
      startdate: fromdt,
      enddate: todt,
      limit: 40,
      offset: 0,
      authorized: authorized,
      main_pro: main_pro,
      owner_id: owner_id,
      userID: user_ID,
      pat_share: storedNames.pat_share,
      facility: facility || "",
    };

    // try calling real API (if backend exists). Use PUT to match Eligibility style.
    try {
      const enc = Encrypt_Value(article, "vozo");
      const resp = await axiosInstance.put("/vozo/unappliedCredit", enc);
      // Decrypt response same as Eligibility
      const decoded = Decrypt_Value(resp.data, "vozo");
      // decoded expected to be an array rows
      if (Array.isArray(decoded) && decoded.length > 0) {
        // set mainrows and first page (first 15 like Eligibility)
        setmainrows(decoded);
        const items = decoded.slice(0, 15);
        setTableData(items);
        if (decoded.length > 15) {
          setShowLoading("reportDivblock");
        } else {
          setShowLoading("reportDivnone");
        }
      } else {
        // no rows returned: show No Records Found UI
        setmainrows([]);
        setTableData([]);
        setShowLoading("reportDivnone");
      }
    } catch (err) {
      // API not available / error -> fallback to filtering dummyData locally
    }
  };

  // ------------------------- LOAD MORE (pagination) -------------------------
  const loadMore = () => {
    setShowLoading("reportDivblock");
    let data = offVal;
    let final = mainrows;
    let rowscount = tableData.length;
    let res = [];

    for (var i in final) {
      res.push(final[i]);
    }

    if (mainrows.length === rowscount) {
      setShowLoading("reportDivnone");
    }

    if (rowscount >= data - 30 && load_flag === 0) {
      // try to fetch more from backend (if exists)
      setload_flag(1);
      setoffval((v) => v + 40);

      const article = {
        patientid: patientId || "",
        userid: "",
        payerid: "",
        startdate: fromdt,
        enddate: todt,
        limit: 40,
        offset: data,
        authorized: authorized,
        main_pro: main_pro,
        owner_id: owner_id,
        userID: user_ID,
        pat_share: storedNames.pat_share,
        facility: facility || "",
      };

      const enc = Encrypt_Value(article, "vozo");
      axiosInstance
        .put("/vozo/unappliedCredit", enc)
        .then((response) => {
          const temp_role = Decrypt_Value(response.data, "vozo");
          if (Array.isArray(temp_role) && temp_role.length > 0) {
            setmainrows((prev) => [...prev, ...temp_role]);
          }
          setload_flag(0);
        })
        .catch(() => {
          // backend not available — no extra rows to append
          setload_flag(0);
        });
    }

    if (tableData.length <= mainrows.length) {
      let items = [];
      let s = parseInt(rowscount) + 10;
      for (let i = rowscount; i <= s; i++) {
        if (res[i] !== undefined) {
          items.push(res[i]);
        }
      }
      setTableData((mitems) => [...mitems, ...items]);
    }
  };

  // ------------------------- Render -------------------------
  return (
    <>
      {spinner ? (
        <Loader />
      ) : (
        <div>
          <div className="tab_title_main1">
            <div className="tab_title_name">Unapplied Credit Report</div>
          </div>

          <div className="daysheet-snd-layer rep-flex-align-center backgr-chng claim-filter-wrap">
            <style>{`
    /* Scoped placeholder fix for this filter area only */
    .claim-filter-wrap .ant-select-selection-placeholder {
      color: #444 !important;
      opacity: 1 !important;
    }
    /* keep AutoComplete placeholder readable */
    .claim-filter-wrap .ant-input::placeholder { color: #666; opacity: 1; }
  `}</style>
            <div className="eligibility-snd-layer rep-flex-align-center">
              {/* Patient Search - same as Eligibility */}
              <div
                title={showTitle ? patientSearchStr || " Patient" : ""}
                className="for_autoComplete_bi SearchUI"
                style={{ marginRight: 10 }}
              >
                <AiOutlineSearch />
                <AutoComplete
                  virtual={false}
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  id="search-btn-hover"
                  placeholder="Patient Search by Name,SSN,Email,DOB"
                  className="remainderWidthSheet"
                  onSelect={(data) => PatientSelect(data)}
                  onChange={(data) => PatientSearch(data)}
                  dropdownClassName={
                    patientSearchStr !== "" ? "" : "for_no_loading"
                  }
                  dropdownRender={(menu) => (
                    <div
                      onMouseEnter={() => setShowTitle(false)}
                      onMouseLeave={() => setShowTitle(true)}
                    >
                      {menu}
                    </div>
                  )}
                  notFoundContent={
                    patientOptions.length !== 0
                      ? "loading.."
                      : "No Result Found"
                  }
                  onClick={() => {
                    if (patientSearchStr) {
                      patdropdown();
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      patdropdown();
                    }
                  }}
                  options={patientOptions.map((x) => {
                    const titleLength = x.title.length;
                    const titleText = x.title;
                    return {
                      label: (
                        <div>
                          <div className="toplabel" title={titleText}>
                            {titleLength < 15 ? (
                              <>
                                {x.title} -{" "}
                                {x.dob ? moment(x.dob).format(dateFormat) : ""}
                              </>
                            ) : (
                              <>
                                <div>{x.title} -</div>
                                <div>
                                  {x.dob
                                    ? moment(x.dob).format(dateFormat)
                                    : ""}
                                </div>
                              </>
                            )}
                          </div>
                          <div>
                            {(() => {
                              const { countryCode, phoneNumber } =
                                parsePhoneForDisplay(
                                  (x.phone_cell || "").replace(
                                    /[^0-9+_ ]/g,
                                    "",
                                  ),
                                  countryCodes,
                                );
                              return `${countryCode} ${phoneNumber}`.trim();
                            })()}
                          </div>
                        </div>
                      ),
                      value: x.pid + "-" + x.name,
                    };
                  })}
                  value={patientSearchStr}
                />
              </div>

              {/* Facility select (ProductProcedures style) */}
              {/* <div className="rep-day-sht-btn m-t-16 demoPaymentControl">
                <Select
                  virtual={false}
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  placeholder="Facility"
                  className=" w-100 t-a-l antd-dd-pay_anly"
                  onChange={(val, data) => setFacility(val)}
                  value={facility ? facility : undefined}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.title ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  {facilityList.map((row, ind) => (
                    <Option
                      key={row.officeid + ind}
                      value={row.officeid}
                      title={row.Office}
                    >
                      {row.Office}
                    </Option>
                  ))}
                </Select>
              </div> */}

              {/* Date Range */}
              {/* <div
                className="ds-flex1"
                id="rpt_pay-inp_dt"
                style={{ marginRight: 10 }}
              >
                <RangePicker
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  onChange={(e) => {
                    if (e != null) {
                      if (e[0] && e[1]) {
                        setfrom(moment(e[0], dateFormat).format("YYYY/MM/DD"));
                        settodt(moment(e[1], dateFormat).format("YYYY/MM/DD"));
                      }
                    } else {
                      setfrom("");
                      settodt("");
                    }
                  }}
                  defaultValue={[
                    moment(fromdt, "YYYY/MM/DD"),
                    moment(todt, "YYYY/MM/DD"),
                  ]}
                  format={dateFormat}
                  inputReadOnly={true}
                  allowClear={false}
                />
              </div> */}

              <div
                className="claim_report_date_picker"
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexShrink: 0,
                  whiteSpace: "nowrap",
                  marginLeft: "20px",
                }}
              >
                <span
                  style={{
                    // color: "#2d3748",
                    fontWeight: 600,
                    marginRight: "8px",
                    marginLeft: "8px",
                    position: "relative",
                    top: "8px",
                  }}
                >
                  From
                </span>

                <DatePicker
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  value={fromdt ? moment(fromdt, "YYYY-MM-DD") : null}
                  format={dateFormat}
                  inputReadOnly
                  allowClear={false}
                  style={{
                    width: 140,
                    position: "relative",
                    top: "8px",
                  }}
                  onChange={(date) => {
                    if (date) {
                      setfrom(moment(date).format("YYYY-MM-DD"));
                    } else {
                      setfrom("");
                    }
                  }}
                />

                <span
                  style={{
                    fontWeight: 600,
                    marginRight: "8px",
                    marginLeft: "8px",
                    position: "relative",
                    top: "8px",
                  }}
                >
                  To
                </span>

                <DatePicker
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  value={todt ? moment(todt, "YYYY-MM-DD") : null}
                  format={dateFormat}
                  inputReadOnly
                  allowClear={false}
                  style={{
                    width: 140,
                    position: "relative",
                    top: "8px",
                  }}
                  onChange={(date) => {
                    if (date) {
                      settodt(moment(date).format("YYYY-MM-DD"));
                    } else {
                      settodt("");
                    }
                  }}
                />
              </div>

              {/* Update */}
              <div className="rep-day-sht-btn m-t-8">
                <Button
                  className="btn-fnt-wgt button_Click_event_alt"
                  style={{
                    position: "relative",
                    top: "4px",
                  }}
                  variant="primary"
                  onClick={() => {
                    onSubmit();
                  }}
                >
                  Update
                </Button>
              </div>
            </div>
          </div>

          {/* Table */}
          <div className="appoint_report_card prior_rep_card_table">
            <Card>
              <Card.Header>
                <div className="modif">
                  <div className="modif_left pat_flag_tit_alt1">
                    Unapplied Credit list
                  </div>
                </div>
              </Card.Header>

              <div className="bill_summary_table">
                <Table className="appt_rep_table_responsive">
                  <TableHead
                    className="Tab_content_Table_Header appt-head "
                    display="table-header-group"
                    height="40px"
                  >
                    <Tablerow
                      className="schedule-head-row tr-no"
                      fontWeight="400"
                      color={globalColor}
                    >
                      <TableHeadCell align="left">Patient</TableHeadCell>
                      {/* <TableHeadCell align="left">Facility</TableHeadCell> */}
                      <TableHeadCell align="left">Payment Date</TableHeadCell>
                      <TableHeadCell align="left">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            lineHeight: "16px",
                          }}
                        >
                          <span> Original Paid</span>
                          <span> Amount</span>
                        </div>
                      </TableHeadCell>
                      <TableHeadCell align="left">Applied Amount</TableHeadCell>
                      <TableHeadCell align="left">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            lineHeight: "16px",
                          }}
                        >
                          <span>Unapplied</span>
                          <span>Credit Amount</span>
                        </div>
                      </TableHeadCell>
                      <TableHeadCell align="left">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            lineHeight: "16px",
                          }}
                        >
                          <span>Current Patient</span>
                          <span>Balance</span>
                        </div>
                      </TableHeadCell>
                    </Tablerow>
                  </TableHead>

                  <TableBody className="tble-over appt_tab_alt1">
                    {tableData.length > 0 ? (
                      <>
                        {tableData.map((row, idx) => (
                          <Tablerow
                            key={idx}
                            className="table-data-row schedule-body-row"
                            fontFamily={globalFont}
                            borderBottom="1px solid #cbd5e0"
                            padding="6px 0 6px 18px"
                            color="#636d73"
                            height="56px"
                          >
                            <TableBodyCell lineHeight="20.02px">
                              {row.patient}
                            </TableBodyCell>
                            {/* <TableBodyCell align="left" lineHeight="20.02px">
                              {row.facility}
                            </TableBodyCell> */}
                            <TableBodyCell align="left" lineHeight="20.02px">
                              {moment(row.payment_date, "YYYY-MM-DD").format(
                                dateFormat,
                              )}
                            </TableBodyCell>
                            <TableBodyCell
                              align="left"
                              className="appTextColor"
                              lineHeight="20.02px"
                            >
                              ${row.original_paid_amount}
                            </TableBodyCell>
                            <TableBodyCell align="left" lineHeight="20.02px">
                              ${row.applied_amount}
                            </TableBodyCell>
                            <TableBodyCell align="left" lineHeight="20.02px">
                              ${row.unapplied_credit_amount}
                            </TableBodyCell>
                            <TableBodyCell align="left" lineHeight="20.02px">
                              ${row.current_patient_balance}
                            </TableBodyCell>
                          </Tablerow>
                        ))}
                      </>
                    ) : (
                      <>
                        <Tablerow className="bot_border">
                          <TableBodyCell
                            className="appCellCenter patpor_main_div"
                            colSpan={7}
                          >
                            <div className="img_top">
                              <Image
                                height="133px"
                                width="133px"
                                src={Emp_data_pic}
                              ></Image>
                            </div>
                          </TableBodyCell>
                        </Tablerow>
                      </>
                    )}
                  </TableBody>
                </Table>
              </div>
            </Card>

            {/* Load more */}
            {tableData.length !== 0 && (
              <div
                className={
                  "loading-more pat_flg_loadmore_btn_alt " + showLoading
                }
              >
                <Button
                  id="load-data"
                  style={{ display: showLoading, paddingTop: 16 }}
                  variant="primary"
                  className="loading-more-div"
                  onClick={loadMore}
                >
                  Load more...
                </Button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default UnappliedCreditReportTable;
